import { EROLE } from "../enums/role.enum";
import {
  ICreateInviteUser,
  IInviteUser,
  IUpdateInviteUser,
} from "../model/invite-user.model";
import { IUpdateUserRole, IUser } from "../model/user.model";
import client from "../utils/client";

export default class UserManagementService {
  prefix = "user-management";
  headers: Headers = new Headers();

  constructor(unitId?: string) {
    if (unitId) {
      this.headers.append("X-UNIT-ID", unitId);
    }
  }

  signup = (data: Types.SignupRequest): Promise<Types.RequestResponse<null>> =>
    client.create(`${this.prefix}/users/signup`, data);

  getUsers = (): Promise<Types.RequestResponse<Types.IResponseList<IUser>>> =>
    client.get(`${this.prefix}/users`, null, this.headers);

  accessRoleToUser = (
    userId: string,
    data: IUpdateUserRole
  ): Promise<Types.RequestResponse<null>> =>
    client.create(
      `${this.prefix}
/users/${userId}/permissions`,
      data,
      this.headers
    );

  deleteUserRole = (data: {
    userId: string;
    unitId: string;
    role: EROLE;
  }): Promise<Types.RequestResponse<null>> =>
    client.remove(
      `${this.prefix}/users/${data.userId}/units/${data.unitId}/roles/${data.role}`,
      null,
      this.headers
    );

  getInvitedUsers = (
    organizationId: string
  ): Promise<Types.RequestResponse<{ invitations: Array<IInviteUser> }>> =>
    client.get(
      `${this.prefix}/organizations/${organizationId}/invitations`,
      null,
      this.headers
    );

  inviteUser = (
    userID: string,
    data: ICreateInviteUser
  ): Promise<Types.RequestResponse<null>> => {
    this.headers.append("X-USER-ID", userID.toString());
    return client.create(
      `${this.prefix}/organization-invitations`,
      data,
      this.headers
    );
  };

  editInviteUser = (
    ids: {
      organizationId: string;
      invitationId: string;
    },
    data: IUpdateInviteUser
  ): Promise<Types.RequestResponse<null>> =>
    client.update(
      `${this.prefix}/organizations/${ids.organizationId}/invitations/${ids.invitationId}`,
      data,
      this.headers
    );
}
